import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
  itens: [],
  total: 0.0,
  id: null,
  cpfClienteVendas: '',
  estadoPedido: '',
  nomeCliente: '',
});

function cartAmount(itens) {
    return itens.map(i => i.quantidade * i.preco).reduce((a, b) => a + b, 0);
}

class LojaVendaStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.CLOSE_CART_FINISH:
            case ActionTypes.DELETE_CART_FINISH:
            case ActionTypes.CREATE_CART_START:
            case ActionTypes.LOGIN_FINISH:
                return new State();

            case ActionTypes.CREATE_CART_FINISH:
                return state.set('id', action.id);

            case ActionTypes.LIST_CART_ITEMS_FINISH:
                return state
                    .set('itens', action.itens)
                    .set('total', cartAmount(action.itens));

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'cpfClienteVendas')
                    return state.set('cpfClienteVendas', action.value);
                if (action.field === 'estadoPedido')
                    return state.set('estadoPedido', action.value);
                return state;

            case ActionTypes.FIND_CLIENT_NAME_FINISH:
                return state.set('nomeCliente', action.name);

            default:
                return state;
        }
    }
}

export default new LojaVendaStore();



// WEBPACK FOOTER //
// src/stores/LojaVendaStore.js